import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = {
  key: 0,
  class: "state-message"
}
const _hoisted_3 = {
  key: 1,
  class: "state-message state-message--error"
}
const _hoisted_4 = {
  key: 2,
  class: "panels-grid"
}

import { computed, onMounted } from "vue";
import { useUsers } from "@/composables/useUsers";
import DashboardPanel from "@/components/dashboard/DashboardPanel.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const { users, loading, error, fetchUsers } = useUsers();

onMounted(fetchUsers);

const activeUsers = computed(() => users.value.filter((u) => u.isActive));

const inactiveUsers = computed(() => users.value.filter((u) => !u.isActive));

const newUsers = computed(() =>
  [...users.value]
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )
    .slice(0, 5)
);

const loggedInUsers = computed(() => users.value.filter((u) => u.isLoggedIn));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h1", { class: "page-title" }, "Dashboard"),
      _createElementVNode("p", { class: "page-subtitle" }, "Overview of all user activity and status")
    ], -1)),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(DashboardPanel, {
              title: "Active Users",
              dot: "green",
              users: activeUsers.value
            }, null, 8, ["users"]),
            _createVNode(DashboardPanel, {
              title: "Inactive Users",
              dot: "red",
              users: inactiveUsers.value
            }, null, 8, ["users"]),
            _createVNode(DashboardPanel, {
              title: "New Users",
              dot: "purple",
              users: newUsers.value
            }, null, 8, ["users"]),
            _createVNode(DashboardPanel, {
              title: "Logged In",
              dot: "cyan",
              users: loggedInUsers.value
            }, null, 8, ["users"])
          ]))
  ]))
}
}

})